import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import PaymentResult from "./pages/PaymentResult";
import AppLayout from "./components/AppLayout";
import Dashboard from "./pages/app/Dashboard";
import KiImport from "./pages/app/KiImport";
import Ankauf from "./pages/app/Ankauf";
import AnkaufNeu from "./pages/app/AnkaufNeu";
import Sellers from "./pages/app/Sellers";
import Bestand from "./pages/app/Bestand";
import Produkte from "./pages/app/Produkte";
import Kategorien from "./pages/app/Kategorien";
import Verkauf from "./pages/app/Verkauf";
import VerkaufNeu from "./pages/app/VerkaufNeu";
import Buchhaltungsbeleg from "./pages/app/Buchhaltungsbeleg";
import Rechnungen from "./pages/app/Rechnungen";
import Vertraege from "./pages/app/Vertraege";
import Kunden from "./pages/app/Kunden";
import Dokumente from "./pages/app/Dokumente";
import Finanzen from "./pages/app/Finanzen";
import Steuerberater from "./pages/app/Steuerberater";
import Auswertungen from "./pages/app/Auswertungen";
import Mitarbeiter from "./pages/app/Mitarbeiter";
import Einstellungen from "./pages/app/Einstellungen";
import Abrechnung from "./pages/app/Abrechnung";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminTenants from "./pages/admin/AdminTenants";
import AdminPlans from "./pages/admin/AdminPlans";
import AdminAi from "./pages/admin/AdminAi";

function Protected({ children }) {
  const { status } = useAuth();
  const loc = useLocation();
  if (status === "loading") return <div className="min-h-screen flex items-center justify-center text-zinc-400 font-mono text-sm">Laden…</div>;
  if (status === "anon") return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  return children;
}

function AdminOnly({ children }) {
  const { status, user } = useAuth();
  if (status === "loading") return <div className="min-h-screen flex items-center justify-center text-zinc-400 font-mono text-sm">Laden…</div>;
  if (status === "anon") return <Navigate to="/login" replace />;
  if (user?.role !== "superadmin") return <Navigate to="/app" replace />;
  return children;
}

function RootRedirect() {
  const { status, user } = useAuth();
  if (status === "loading") return <div className="min-h-screen flex items-center justify-center text-zinc-400 font-mono text-sm">Laden…</div>;
  if (status === "ok") return <Navigate to={user?.role === "superadmin" ? "/admin" : "/app"} replace />;
  return <Landing />;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
      <Routes>
        <Route path="/" element={<RootRedirect />} />
        <Route path="/login" element={<Login />} />
        <Route path="/registrieren" element={<Register />} />
        <Route path="/zahlung/:result" element={<PaymentResult />} />
        <Route path="/app" element={<Protected><AppLayout /></Protected>}>
          <Route index element={<Dashboard />} />
          <Route path="ki-import" element={<KiImport />} />
          <Route path="ankauf" element={<Ankauf />} />
          <Route path="ankauf/neu" element={<AnkaufNeu />} />
          <Route path="verkaeufer" element={<Sellers />} />
          <Route path="bestand" element={<Bestand />} />
          <Route path="produkte" element={<Produkte />} />
          <Route path="kategorien" element={<Kategorien />} />
          <Route path="verkauf" element={<Verkauf />} />
          <Route path="verkauf/neu" element={<VerkaufNeu />} />
          <Route path="verkauf/:saleId/beleg" element={<Buchhaltungsbeleg />} />
          <Route path="rechnungen" element={<Rechnungen />} />
          <Route path="vertraege" element={<Vertraege />} />
          <Route path="kunden" element={<Kunden />} />
          <Route path="dokumente" element={<Dokumente />} />
          <Route path="finanzen" element={<Finanzen />} />
          <Route path="steuerberater" element={<Steuerberater />} />
          <Route path="auswertungen" element={<Auswertungen />} />
          <Route path="mitarbeiter" element={<Mitarbeiter />} />
          <Route path="einstellungen" element={<Einstellungen />} />
          <Route path="abrechnung" element={<Abrechnung />} />
        </Route>
        <Route path="/admin" element={<AdminOnly><AdminLayout /></AdminOnly>}>
          <Route index element={<AdminDashboard />} />
          <Route path="unternehmen" element={<AdminTenants />} />
          <Route path="tarife" element={<AdminPlans />} />
          <Route path="ki-nutzung" element={<AdminAi />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toaster position="top-right" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
